import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicModule } from '@ionic/angular';
import { ModalService } from '../../services/modal.service';
import { ButtonComponent } from '../../components/button/button.component';
import { AppUpdateService } from '../../services/app-update.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'native-app-update-available-modal',
  templateUrl: './native-app-update-available-modal.page.html',
  styleUrl: './native-app-update-available-modal.page.scss',
  imports: [TranslateModule, IonicModule, ButtonComponent],
})
export class NativeAppUpdateAvailableModalPage {
  constructor(
    private modalService: ModalService,
    private appUpdateService: AppUpdateService,
  ) {}

  closeModal(): void {
    void this.modalService.dismiss();
  }

  updateApp(): void {
    void this.appUpdateService.goToStore();
  }
}
